import { render, staticRenderFns } from "./SettingsNavbar.vue?vue&type=template&id=3e1dfd4e&"
import script from "./SettingsNavbar.vue?vue&type=script&lang=js&"
export * from "./SettingsNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports